import styled from 'styled-components';
import { BulkEditButton } from '../../../components/styles';

export const SubcategoryContainer = styled.div`
  margin-top: 8px;
`;

export const AvgSeatCountColumn = styled(BulkEditButton)`
  margin: -8px 0 0;
`;
